import React from 'react';
import { Route } from 'react-router-dom';
import { PublicLayout } from '../components/PublicLayout';
import { OAuthConsentPage } from '../pages/OAuthConsentPage';
import { LandingPage } from '../pages/LandingPage';
import { AppPrivacyPage } from '../pages/AppPrivacyPage';
import { AvailabilityPage } from '../pages/AvailabilityPage';
import { TermsPage } from '../pages/TermsPage';
import { PrivacyPolicyPage } from '../pages/PrivacyPolicyPage';
import { SupportPage } from '../pages/SupportPage';
import { DeleteAccountPage } from '../pages/DeleteAccountPage';
import { LoginPage } from '../pages/LoginPage';
import { RegisterPage } from '../pages/RegisterPage';
import { VerifyRegistrationPage } from '../pages/VerifyRegistrationPage';
import { HealthPage } from '../pages/HealthPage';
import { ForgotPasswordPage } from '../pages/ForgotPasswordPage';
import { ResetPasswordPage } from '../pages/ResetPasswordPage';
import { ConfirmEmailChangePage } from '../pages/ConfirmEmailChangePage';
import { OrgInviteAcceptPage } from '../pages/OrgInviteAcceptPage';
import { InvitationAcceptPage } from '../pages/InvitationAcceptPage';
import { PublicTaskPage } from '../pages/PublicTaskPage';

/** Routes reachable without signing in. Rendered directly under <Routes>. */
export const publicRoutes = (
    <Route element={<PublicLayout />}>
        <Route path="/" element={<LandingPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/app-privacy" element={<AppPrivacyPage />} />
        <Route path="/availability" element={<AvailabilityPage />} />
        <Route path="/terms" element={<TermsPage />} />
        {/* Both stores require a Support URL that resolves. Without
            this route /support fell through to the SPA 404→index
            rewrite, which renders as a page rather than an error —
            so a missing support page would have looked fine. */}
        <Route path="/support" element={<SupportPage />} />
        {/* Public on purpose. Play requires a deletion route usable
            by someone who has already uninstalled the app, so this
            cannot sit behind ProtectedRoute — it resolves for a
            signed-out visitor and sends them through sign-in. */}
        <Route path="/delete-account" element={<DeleteAccountPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/verify-registration" element={<VerifyRegistrationPage />} />
        <Route path="/health" element={<HealthPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/confirm-email-change" element={<ConfirmEmailChangePage />} />
        <Route path="/invitations/:token/accept" element={<InvitationAcceptPage />} />
        <Route path="/invitations/org/:token" element={<OrgInviteAcceptPage />} />
        {/* MCP OAuth consent (authorization_endpoint) — handles its own auth. */}
        <Route path="/oauth/authorize" element={<OAuthConsentPage />} />
        {/* A task's "Public Link" — read-only, no sign-in. */}
        <Route path="/public/tasks/:slug" element={<PublicTaskPage />} />
    </Route>
);
